import { PrescriptionAssistantModal } from '@/shared-ui/PrescriptionAssistantModal/PrescriptionAssistantModal';

interface CompleteConsultModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const CompleteConsultationModal = ({ isOpen, onConfirm, onClose }: CompleteConsultModalProps) => {
  return (
    <PrescriptionAssistantModal
      open={isOpen}
      title="Confirm Consult Completion?"
      severity="warning"
      body="You are about to complete this consultation without making any changes to the patient's prescriptions. Any notes you've added will be saved."
      confirmLabel="Yes, Complete Consultation"
      closeLabel="Cancel"
      onConfirm={() => onConfirm()}
      onClose={() => onClose()}
    />
  );
};
